export default "__VITE_ASSET__05f9b727__"